module.exports = __webpack_public_path__ + "static/media/beep2.cdcaa970.mp3";